(function($) {

    $(document).ready(function() {
        var $document = $(document);
        var $body = $(document.body);
        var $HeaderDropDowns = $('.container-header-nav .dropdown-menu, .mega-nav');
        var $dropdownButtons = $('header .js-dropdown-button');
        var $subMenuBtn = $('.nav-menu .sub-menu-btn');
        var $menuBackItems = $('.nav-menu li > .mobile-menu-back');
        var mobileBreakpoint = 751;

        $dropdownButtons.on('click', dropDownButtonClick);
        $subMenuBtn.on('click', onMenuItemClick);
        $menuBackItems.on('click', onBackItemClick);

        function setMenuToZero() {
            $HeaderDropDowns.removeClass('submenu-open');
            $HeaderDropDowns.find('.menu-open').removeClass('menu-open');
        };

        function dropDownButtonClick(e) {
            e.preventDefault();

            var $this = $(this);
            var $dropDown = $('#' + $this.attr('aria-controls'));
            var isOpen = $dropDown.hasClass('open');

            if (isOpen) { 
                closeDropdownMenu($dropDown);
                $dropDown.off('click.closeafternav');
            }
            else {
                openDropdownMenu($this, $dropDown);  
                $dropDown.one('click.closeafternav', 'a', function(e){
                    closeDropdownMenu($dropDown);
                });
            }
        };

        function closeDropdownMenu($dropDown) {
            $dropDown.removeClass("open").attr("aria-hidden", true)
            setMenuToZero()
            $body.off("click.header-dropdown-menu-listener");
            $('[aria-controls=' + $dropDown.attr('id') + ']')
                .removeClass('is-open')
                .removeAttr('aria-expanded');

            $document.off("keydown.escapeKeyPressed");
        };

        function openDropdownMenu($button, $dropDown) {
            //Be certain all dropdowns are closed, before opening a new dropdown
            closeDropdownMenu($HeaderDropDowns);
            
            $button
                .addClass('is-open')
                .attr('aria-expanded', 'true')
                .blur();

            $dropDown
                .addClass("open")
                .attr("aria-hidden", false);
            
            $dropDown                
                .find('a[aria-hidden!="true"]').first()
                .focus();


            $body.on("click.header-dropdown-menu-listener", {'button': $button, 'dropDown': $dropDown}, reactOnClicksOutsideDropdownMenu);
            addListenerForEscapeKey(closeDropdownMenu, $dropDown);
        };

        function onMenuItemClick(e) {
            var isMobile = document.documentElement.offsetWidth <= mobileBreakpoint;        
            if (!isMobile) {
                return;
            }

            var button = $(e.currentTarget).parents('ul > li');
            $HeaderDropDowns.addClass('submenu-open');
            button.addClass('menu-open');
            button.children('.mobile-menu-back').focus();
            $(e.target).attr('aria-expanded', 'true');
        };

        function onBackItemClick(e) {
            var isMobile = document.documentElement.offsetWidth <= mobileBreakpoint;
            if (!isMobile) {
                return;
            }

            var button = $(e.currentTarget).parent();
            $HeaderDropDowns.removeClass('submenu-open');
            button
                .removeClass('menu-open')
                .children('.sub-menu-btn')
                .removeAttr('aria-expanded')
                .focus();        
        };

        function reactOnClicksOutsideDropdownMenu(ev) {
            var $button = ev.data.button;
            var $dropDown = ev.data.dropDown;

            if (targetOriginatesFromOutsideOfElement($button, ev.target)
            && targetOriginatesFromOutsideOfElement($dropDown, ev.target)) {
                closeDropdownMenu($dropDown);
            }
        };

        function targetOriginatesFromOutsideOfElement(element, target) {
            return !$(element).is(target) && !$(element).find(target).length;
        };

        function addListenerForEscapeKey(func, $dropDown) {
            $document.on("keydown.escapeKeyPressed", function(e) {
                if (e.keyCode == 27) { // escape key maps to keycode `27`
                    func($dropDown);
                }
            });
        };

    });

})(jQuery);
